import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Nom035PeopleList from "./Nom035PeopleList";
import Nom035FinalScore from "./Nom035FinalScore";
import Nom035BlockGrade from "./Nom035BlockGrade";
import { useTranslation } from "react-i18next";
import "./Nom035Report.css";

function Nom035Report() {
  const [isLoading, setIsLoading] = useState(true);
  const [people, setPeople] = useState([]);
  const [peopleCount, setPeopleCount] = useState(0);
  const [questionnaireType, setQuestionnaireType] = useState("");
  const [finalScoreLabel, setFinalScoreLabel] = useState("");
  const [categoryArray, setCategoryArray] = useState([]);
  const [domainArray, setDomainArray] = useState([]);
  const [title, setTitle] = useState("");
  const [filter, setFilter] = useState("");
  const [categories, setCategories] = useState([]);

  const { state } = useContext(AuthContext);

  let { rid } = useParams();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/reports/survey/nom035/${rid}`,
        data: {
          language: state.language,
          filter: filter,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setPeople(response.data.people);
      setPeopleCount(response.data.peopleCount);
      setQuestionnaireType(response.data.questionnaireType);
      setTitle(response.data.title);
      setCategories(response.data.categories);
      if (
        response.data.questionnaireType === "psychosocial" ||
        response.data.questionnaireType === "environment"
      ) {
        setFinalScoreLabel(response.data.finalScoreLabel);
        setCategoryArray(response.data.categoryArray);
        setDomainArray(response.data.domainArray);
      }
      setIsLoading(false);
    }
    fetch();
  }, [state.language, rid, state.token, filter]);

  const filterResults = async (e) => {
    setIsLoading(true);
    setFilter(e.target.value);
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/reports/survey/nom035/${rid}`,
      data: {
        language: state.language,
        filter: e.target.value,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    setPeople(response.data.people);
    setPeopleCount(response.data.peopleCount);
    setQuestionnaireType(response.data.questionnaireType);
    setTitle(response.data.title);
    setCategories(response.data.categories);
    if (
      response.data.questionnaireType === "psychosocial" ||
      response.data.questionnaireType === "environment"
    ) {
      setFinalScoreLabel(response.data.finalScoreLabel);
      setCategoryArray(response.data.categoryArray);
      setDomainArray(response.data.domainArray);
    }
    setIsLoading(false);
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    if (questionnaireType === "traumatic") {
      return (
        <Container fluid>
          <Row>
            <Col className="mb-3 center">
              <h2>{title}</h2>
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <h4>Trabajadores sujetos a acontecimientos traumaticos</h4>
            </Col>
          </Row>
          <Row>
            {people.length === 0 ? (
              <Col className="empty-people center">
                <h5>{t("Personas.SinPersonas")}</h5>
              </Col>
            ) : (
              <Nom035PeopleList people={people} language={state.language} />
            )}
          </Row>
        </Container>
      );
    } else if (
      questionnaireType === "psychosocial" ||
      questionnaireType === "environment"
    ) {
      return (
        <Container fluid>
          <Row>
            <Col className="mb-3 center">
              <h2>{title}</h2>
              <h6>{peopleCount} personas participantes</h6>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Select
                  className="mb-3"
                  name="categories"
                  onChange={(e) => filterResults(e)}
                  value={filter}
                >
                  <option value={""}>{t("Reportes.Filtar")}</option>
                  {categories.map((item) => (
                    <option key={item._id} id={item._id} value={item._id}>
                      {state.language === "es" ? item.name : item.name_english}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          {filter === "" ? (
            <Row>
              <Col className="mb-3">
                <Nom035FinalScore finalScoreLabel={finalScoreLabel} />
              </Col>
            </Row>
          ) : (
            <></>
          )}
          <Row>
            <h3>Categorías</h3>
            <Col className="mb-3">
              {categoryArray.map((item) => (
                <Nom035BlockGrade
                  key={item.category}
                  title={item.category}
                  total={item.total}
                  label={item.label}
                />
              ))}
            </Col>
          </Row>
          <Row>
            <h3>Dominios</h3>
            <Col>
              {domainArray.map((item) => (
                <Nom035BlockGrade
                  key={item.domain}
                  title={item.domain}
                  total={item.total}
                  label={item.label}
                />
              ))}
            </Col>
          </Row>
        </Container>
      );
    }
  }
}

export default Nom035Report;
